<template lang="html">
  <section class="main-view">
    <div class="container-scroller">
      <app-header/>
      <div class="container-fluid page-body-wrapper">
        <app-sidebar/>
        <div class="main-panel">
          <div class="content-wrapper">
            <router-view></router-view>
          </div>
          <!-- content wrapper ends -->
          <app-footer/>
        </div>
        <!-- main panel ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </section>
</template>

<script lang="js">
import AppHeader from '../../components/Layouts/AppHeader'
import AppSidebar from '../../components/Layouts/AppSidebar'
import AppFooter from '../../components/Layouts/AppFooter'
export default{
  name: 'home',
  components: {
    AppHeader,
    AppSidebar,
    AppFooter
  }
}
</script>